import React from 'react';

interface TextProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl';
}

export function Text({ 
  children, 
  className = '',
  align = 'left',
  size = 'base'
}: TextProps) {
  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const sizeClasses = {
    xs: 'text-xs md:text-sm',
    sm: 'text-sm md:text-base',
    base: 'text-base md:text-lg',
    lg: 'text-lg md:text-xl',
    xl: 'text-xl md:text-2xl'
  };

  return (
    <span className={`font-gabarito ${alignmentClasses[align]} ${sizeClasses[size]} ${className}`}>
      {children}
    </span>
  );
}